<template>
  <div class="post-content">
    <MediaSlider
      v-if="postType == PostTypes.MEDIA"
      :attachments="attachments"
      :postID="postID"
      :continue_video="continue_video"
      @showpopup="showPopUp($event)"
      @showVideoPopup_event="showPopUp_Video($event)"
      @is_media_clicked="$emit('is_media_clicked', $event);"
    />
    <div
      v-if="
        postType == PostTypes.OG ||
        postType == PostTypes.TEXT ||
        postType == PostTypes.YOUTUBE ||
        postType == PostTypes.GIF_LINK
      "
      class="non-slider-container"
    >
      <!-- IF youtube/GIF exists only one item/attachment will be available so we do :link="attachments[0].link" #TODO enhance it to be more predictable -->
      <PostGIF
        v-if="postType == PostTypes.GIF_LINK"
        :link="attachments[0].link"
        @click.native="showPopUp($event)"
      />
      <PostYoutube
        v-if="postType == PostTypes.YOUTUBE"
        :postID="postID"
        :link="attachments[0].link"
      />
      <OgTagsPreview
        v-if="postType == PostTypes.OG"
        v-bind="ogTags"
        :content="text"
      />
      <TextOverlay
        v-if="postType == PostTypes.TEXT"
        :content="text"
        @click.native="$emit('is_media_clicked', $event);"
      />
    </div>
  </div>
</template>



<script>
import MediaSlider from "./media-slider.vue";
import OgTagsPreview from "./og-tags-preview.vue";
import TextOverlay from "./text-overlay.vue";
import { PostTypes, AttachmentType } from "./enums.js";
import { getPostTypeBasedOnAttachments } from "./helpers.js";
import jQuery from "jquery";
import ReRenderer from "../../mixins/re-renderer.vue";
import PostYoutube from "./post-youtube.vue";
import PostGIF from "./post-gif.vue";

export default {
  mixins: [ReRenderer],
  components: {
    MediaSlider: MediaSlider,
    OgTagsPreview: OgTagsPreview,
    TextOverlay: TextOverlay,
    PostYoutube: PostYoutube,
    PostGIF: PostGIF,
  },
  data() {
    return {
      reRenderCssSelectors: [
        {
          jquerySelectors: ".post-content",
          properties: [
            {
              propertyName: "height",
              propertyValue: this.getWindowHeightInPx,
              isCallBack: true,
            },
          ],
        },
        {
          jquerySelectors: ".non-slider-container",
          properties: [
            {
              propertyName: "height",
              propertyValue: this.getWindowHeightInPx,
              isCallBack: true,
            },
          ],
        },
      ],
      PostTypes: PostTypes,
      AttachmentType: AttachmentType,
    };
  },
  props: {
    text: {
      type: String,
    },
    attachments: {
      type: Array,
    },
    ogTags: {
      type: Object,
    },
    postID: {
      type: String,
    },
    continue_video: {
      type: Boolean,
    },
  },
  computed: {
    postType() {
      return getPostTypeBasedOnAttachments(this.attachments, this.ogTags);
    },
  },
  methods: {
    showPopUp(value) {
      this.$emit("showpopup", value);
    },
    showPopUp_Video(value) {
      this.$emit("showVideoPopup_event", value);
    },
  },
  mounted() {
    jQuery(document).ready(function () {
      jQuery(".post-content").css("height", jQuery(window).height() + "px");
    });
  },
};
</script>



<style scoped>
.post-content {
  height: 100%;
}
.non-slider-container {
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
</style>
